import { openModal } from "../../ui/containers/Modal";
import { createElement } from "../../ui/ui";
import { Actor } from "../actors/Actor";
import { FontParticle } from "../anims/particles/FontParticle";
import { ParticleManager } from "../anims/particleSystem";
import Colors from "../Colors";
import { gameData } from "../GameManager";
import { generateMap } from "../map/generation/generation";
import { ShrineMap } from "../map/ShrineMap";
import { VictoryModal } from "../ui/endConds/victory";

const MAP_DEPTH_SIZES = [0, 25, 33, 33, 33, 25]; //0 & 1 depths aren't used

const fontRest = async (actor: Actor, newLevel = false) => {
  actor.health.fill();
  actor.stamina.fill();
  actor.poise.fill();
  actor.contains.forEach((i) => {
    if (i.uses && i.breed.usable && i.breed.usable.fillOnRest) {
      i.uses.fill();
    }
  });
  if (actor === gameData.player) {
    await ParticleManager.runThenDestroy(FontParticle, actor.x, actor.y);
    gameData.items.clear();
    gameData.actors.clear();
    gameData.gibs.clear();
    gameData.particles.clear();
    gameData.actors.add(gameData.player.id, gameData.player);
    if (newLevel) {
      gameData.current = new ShrineMap(
        MAP_DEPTH_SIZES[gameData.current.depth + 1],
        MAP_DEPTH_SIZES[gameData.current.depth + 1],
        gameData.seedRng.getGenerator(),
        gameData.current.depth + 1
      );
    }
    generateMap(
      gameData.current.rng.getRNG(),
      gameData.current,
      gameData.player
    );
  }
};

export const furniture = {
  oldFont: {
    displayPriority: 15,
    glyph: {
      fg: Colors.RED_4,
      ch: "_",
    },
    text: {
      name: "A tended shrine",
      info:
        "Interact with the shrine to rest, restoring your health and flask.",
      description:
        "Among the shifting planes those that came before have built shrines dedicated to their cause. This one has been visited recently.",
      logName: "font",
    },
    furniture: true,
    interact: async (actor: Actor) => {
      await fontRest(actor);
    },
  },
  newFont: {
    displayPriority: 15,
    glyph: {
      fg: Colors.RED_4,
      ch: "_",
    },
    text: {
      name: "A neglected shrine",
      info: "Interact with the shrine to rest and journey onwards.",
      description:
        "Among the shifting planes those that came before have built shrines dedicated to their cause. You are the first one to find this shrine in a long time.",
      logName: "shrine",
    },
    furniture: true,
    interact: async (actor: Actor) => {
      if (gameData.current.depth === 5) {
        openModal(createElement(VictoryModal, { x: 0, y: 0, w: 32, h: 32 }));
      } else {
        await fontRest(actor, true);
      }
    },
  },
} as const;
